export default "https://cdn.questicon.mathletics.com/assets/images/Move-fb2662766da14007a32ce0ee782e692f.svg";